import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';

import { Subscription } from 'rxjs';
import { User } from 'firebase/auth';
import { ToastService } from '@shared/components/toast/toast.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  imports: [RouterLinkActive, RouterLink],
})
export class NavbarComponent implements OnInit, OnDestroy {
  isAuthenticated: boolean = false;

  private readonly authService = inject(AuthService);
  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);
  private authSubscription: Subscription;

  ngOnInit() {
    this.authSubscription = this.authService.authState$.subscribe((aUser: User | null) => {
      this.isAuthenticated = !!aUser && aUser.emailVerified;
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  async logOut() {
    try {
      await this.authService.logOut();
      this.router.navigate(['/auth/login']);
    } catch (error) {
      this.toastService.showError(`Logout failed: ${error}`);
    }
  }

  goToProfile() {
    this.router.navigate(['settings/profile']);
  }
}
